import React from 'react';
import RadioButtons from './RadioButtons';

export default ({ name, value, onChange, trueLabel = 'Yes', falseLabel = 'No' }) => (
  <RadioButtons
    name={name}
    onChange={(newVal) => onChange(newVal === 'true')}
    value={value == null ? null : value.toString()}
    choices={[
      { value: 'true', label: trueLabel },
      { value: 'false', label: falseLabel }
    ]}
  />
);



// WEBPACK FOOTER //
// ./src/components/BooleanRadioButtons.js